import { createActionWithCallbacks } from '@move-frontend/auth';
import { sendRecoveryLink } from '../../domain/use-cases/sendRecoveryLink';

export const sendRecoveryLinkWithCallbacks =
	createActionWithCallbacks(sendRecoveryLink);
